module.exports = __webpack_public_path__ + "static/img/fotovaleaguilera.1d6b823.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/miembros/fotovaleaguilera.jpeg
// module id = xs5g
// module chunks = 0